import { Directive, Input, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/** Birth date must be within 100 years and not be past current date */
export function dobValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        //const forbidden = 
        const isValid = validateDateOfBirth(control.value);
       
        return !isValid ? { 'validDob': { value: control.value } } : null;
    };
}


export function validateDateOfBirth(dob: string): boolean {

   
    var currentDate = new Date();
    if (dob != null) {       
        // initially setting ngmodel of a masked input must be in this format "02031980" 
        //so must convert to parseable string
        if (dob.length == 6) { 
            dob = [dob.slice(0, 2), '/01/', dob.slice(2)].join('');
        }

        if (dob.indexOf('/') < 0)
            dob = dob.substr(0, 2) + '/' + dob.substr(2, 2) + '/' + dob.substr(4);

        
        var timestamp = Date.parse(dob);

        if (!isNaN(timestamp)) {
            var date = new Date(dob);

            if (date < currentDate) {

                if (date.getFullYear() > (currentDate.getFullYear() - 100)) {

                    // extra check to determine if valid calendar date
                    if (isvalid_mdy(dob)) {
                        return true;
                    }
                    else
                    {
                        return false;
                    }
                }
            }

        }

    }

    return false;
}

// fxn to determine if a valid calendar date - like 02/31/1999 ,  which is bad
export function isvalid_mdy(s) {
    var day, A = s.match(/[1-9][\d]*/g);
    try {
        A[0] -= 1;
        day = new Date(+A[2], A[0], +A[1]);
        if (day.getMonth() == A[0] && day.getDate() == A[1]) {
            return true;
        }

        return false;
    }
    catch (er) {
        alert(er.message);
        return er.message;
    }
}

@Directive({
    selector: '[validDob]'
})
export class DobValidatorDirective  {

    @Input()
    validDob: AbstractControl;



    constructor() { }

    @HostListener('focusout', ['$event.target'])
    onFocusout(target) {
        
        this.validate();

    }

    @HostListener('document:triggerValidation', ['$event.target'])
    onsubmit() {
        
        this.validate();
    }

    validate() {

        if (!this.validDob.errors) {

            this.validDob.setErrors(dobValidator()(this.validDob));

        }
    }
}

